import bildJa from '@/assets/icons/ja.svg';
import bildNein from '@/assets/icons/nein.svg';

export const monumentAnswers = [
    { name: 'Ja', available: false, value: 'ja', api: '21002', image: bildJa },
    { name: 'Nein', available: true, value: 'nein', api: '21003',  image: bildNein },
];

export const monumentApi = {parameter: '17987', type: 'value_choice'};